var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "emd-application" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "click-outside",
            rawName: "v-click-outside",
            value: _vm.clickedOutside,
            expression: "clickedOutside",
          },
        ],
        ref: "apps",
        staticClass: "emd-dropdown",
      },
      [
        _c(
          "div",
          {
            staticClass: "emd-dropdown__trigger",
            class: { _active: _vm.showApps },
            on: { click: _vm.toggleApps },
          },
          [_vm._m(0)]
        ),
        _c(
          "div",
          {
            staticClass: "emd-dropdown__content",
            class: { _active: _vm.showApps },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "emd-text _color_default _type_label _size_tiny eu-ma_2",
              },
              [_vm._v(_vm._s(_vm.$t("your-apps")))]
            ),
            _c("ul", [
              _c("li", { staticClass: "emd-dropdown__content__item" }, [
                _c(
                  "a",
                  {
                    staticClass: "emd-text _color_default",
                    attrs: { href: _vm.urlDash },
                  },
                  [_c("p", [_vm._v("Dash")])]
                ),
              ]),
              _c("li", { staticClass: "emd-dropdown__content__item" }, [
                _c(
                  "a",
                  {
                    staticClass: "emd-text _color_default",
                    attrs: { href: _vm.urlHub },
                  },
                  [_c("p", [_vm._v("Hub")])]
                ),
              ]),
              _vm.merchantHasConciliation &&
              _vm.permissionIsEnabled("finance:view")
                ? _c("li", { staticClass: "emd-dropdown__content__item" }, [
                    _c(
                      "a",
                      {
                        staticClass: "emd-text _color_default",
                        attrs: { href: _vm.urlFinance },
                      },
                      [_c("p", [_vm._v("Finance")])]
                    ),
                  ])
                : _vm._e(),
            ]),
            _c("div", {
              staticClass: "emd-divider _weight_light eu-mt_2 eu-mb_3",
            }),
            _c(
              "div",
              {
                staticClass:
                  "emd-text _color_default _type_label _size_tiny eu-ma_2",
              },
              [_vm._v(_vm._s(_vm.$t("get-to-know")))]
            ),
            _c("ul", [
              !_vm.merchantHasConciliation &&
              _vm.permissionIsEnabled("finance:view")
                ? _c("li", { staticClass: "emd-dropdown__content__item" }, [
                    _c(
                      "a",
                      {
                        staticClass: "emd-text _color_default",
                        attrs: { href: _vm.urlFinanceDemo },
                      },
                      [
                        _c("p", [
                          _vm._v(" Finance "),
                          _c(
                            "span",
                            { staticClass: "emd-badge _color_success" },
                            [_vm._v(_vm._s(_vm.$t("new")))]
                          ),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm.componentIsEnabled("apps", "antifraud")
                ? _c("li", { staticClass: "emd-dropdown__content__item" }, [
                    _c(
                      "a",
                      {
                        staticClass: "emd-text _color_default",
                        attrs: {
                          href: _vm.urlAntifraude,
                          target: "_blank",
                          rel: "noopener noreferrer",
                        },
                      },
                      [
                        _c("p", [
                          _vm._v(" " + _vm._s(_vm.$t("antifraud")) + " "),
                          _c(
                            "span",
                            { staticClass: "emd-badge _color_success" },
                            [_vm._v(_vm._s(_vm.$t("new")))]
                          ),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "emd-application__content" }, [
      _c("i", { staticClass: "emd-application__icon uil uil-table" }),
      _c("span", { staticClass: "emd-text emd-text _size_section" }, [
        _vm._v("Shop"),
      ]),
      _c("i", { staticClass: "emd-action-button__arrow uil uil-angle-down" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }